var map = {
	"./bolt.svg": 82620,
	"./hand-stars.svg": 1728,
	"./key-square.svg": 4348,
	"./star.svg": 59332,
	"./stars-minimalistic.svg": 5160,
	"./stars-sides.svg": 8672,
	"./stars.svg": 95144
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 17932;